import React from 'react';
import { css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import BodyText from 'components/atoms/BodyText';
import { grayScale } from 'components/styles';
// import Select from 'components/atoms/Select';
// import useEmploymentOptions from 'hooks/useEmploymentOptions';

const EmploymentFilter: React.FC<{
  employmentId: string;
  setEmploymentId: (employmentId: string) => void;
}> = ({ employmentId, setEmploymentId }) =>
// const employmentOptions = useEmploymentOptions();

  (
    <FlexBox
      customStyle={css({
        paddingTop: '8px',
        paddingBottom: '8px',
      })}
    >
      <FlexBoxItem basis="100px">
        <BodyText> スタッフ </BodyText>
      </FlexBoxItem>
      <FlexBoxItem basis="400px">
        <BodyText color={grayScale.gray100}> {`${sessionStorage.getItem('loginUser.staffCode')}  ${sessionStorage.getItem('loginUser.staffName')}`} </BodyText>
      </FlexBoxItem>
    </FlexBox>
  );
export default EmploymentFilter;
